import { render, staticRenderFns } from "./DialogSincronizacao.vue?vue&type=template&id=15541712&scoped=true&"
import script from "./DialogSincronizacao.vue?vue&type=script&lang=js&"
export * from "./DialogSincronizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15541712",
  null
  
)

export default component.exports